import React, { useState, useEffect, useRef } from "react";
import ButtonPrimary from "../../../elements/button/ButtonPrimary";
import SMModal from "../../../elements/modals/SMModal";
import InputSingle from "../../../elements/input/InputSingle";
import SlidingPane from "react-sliding-pane";
import { PencilIcon, PlusIcon, TrashIcon } from "@heroicons/react/outline";
import { Transition } from "@headlessui/react";
import { useHistory, useParams } from "react-router-dom";

// pop over
import { Popover, ArrowContainer } from "react-tiny-popover";
import styled from "styled-components";
import axiosAPI from "../../../utils/axios-api";

const API = process.env.REACT_APP_API;

const Overlays = styled.div`
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  background-color: #00000066;
  left: 0;
`;

const Overlay = (props) => {
  if (props.isOpen) {
    return <Overlays />;
  } else {
    return null;
  }
};

const FormSkala = (props) => {
  const [itemSkala, setitemSkala] = useState(props.initialSkala ?? []);

  useEffect(() => {
    // setitemSkala(props.initialSkala ?? [])
  }, []);

  function increaseSkala(params) {
    setitemSkala([...itemSkala, { key: "", keterangan: "" }]);
  }

  function decreaseSkala(params) {
    let dataTemp = itemSkala.filter((x, y) => y !== params);
    setitemSkala(dataTemp);
  }

  function setKeyValue(e, idx, type) {
    const newData = itemSkala.map((el, idxx) => {
      if (idxx === idx) {
        if (type === 1) {
          return { ...el, key: e };
        } else {
          return { ...el, keterangan: e };
        }
      }
      return el;
    });

    setitemSkala(newData);
  }

  function save(params) {
    props.save(itemSkala);
    props.close();
  }

  return (
    <div className="flex flex-col">
      <h1 className="text-2xl font-bold mb-4">Pengaturan Skala</h1>
      <div className="flex flex-col">
        {itemSkala.slice(0, itemSkala.length).map((val, idx) => {
          let button = null;
          if (idx === 0) {
            button = (
              <div>
                <button
                  className="p-2 rounded bg-green-400 text-white"
                  onClick={() => increaseSkala()}
                >
                  <PlusIcon className="h-4 w-4" />
                </button>
              </div>
            );
          } else if (idx > 1) {
            button = (
              <div>
                <button
                  onClick={() => decreaseSkala(idx)}
                  className="p-2 rounded bg-red-400 text-white"
                >
                  <TrashIcon className="h-4 w-4" />
                </button>
              </div>
            );
          }

          return (
            <div key={idx} className="flex flex-row gap-2 my-2 items-center">
              <div className="flex">
                <InputSingle
                  onChange={(e) => setKeyValue(e.target.value, idx, 1)}
                  value={itemSkala[idx].key}
                  type="text"
                  placeholder="contoh: TS"
                />
              </div>
              <div className="flex flex-1">
                <InputSingle
                  type="text"
                  placeholder="contoh: Tidak Setuju"
                  className="w-full"
                  onChange={(e) => setKeyValue(e.target.value, idx, 2)}
                  value={val.keterangan}
                />
              </div>
              {button}
            </div>
          );
        })}
      </div>

      <p>Jumlah minimal skala adalah 2</p>
      <div className="flex flex-row gap-2 my-4">
        <button
          onClick={() => props.close()}
          className="px-4 py-2 bg-red-500 text-white rounded"
        >
          Batal
        </button>
        <button
          onClick={() => save()}
          className="px-4 py-2 bg-blue-500 text-white rounded"
        >
          Simpan
        </button>
      </div>
    </div>
  );
};

// form liklert type 1
const FormLiklertType1 = (props) => {
  const [pernyataan, setpernyataan] = useState(props.initialData ?? [""]);

  function increasePernyataan(params) {
    setpernyataan([...pernyataan, ""]);
    saveAll([...pernyataan, ""]);
  }

  function decreasePernyataan(params) {
    let afterDeleted = pernyataan.filter((x, y) => y !== params);
    setpernyataan(afterDeleted);
    saveAll(afterDeleted);
  }

  function setValue(e, idx) {
    let newData = pernyataan;
    newData[idx] = e;

    setpernyataan(newData);
    saveAll(newData);
  }
  function saveAll(params) {
    props.onSave(params);
  }
  return (
    <div className="flex flex-col">
      <div className="flex flex-col">
        <p className="my-2">Pernyataan</p>
        <div className="flex flex-col gap-4">
          {pernyataan.map((val, idx) => {
            let button = null;
            if (idx === 0) {
              button = (
                <button
                  onClick={() => increasePernyataan()}
                  className="p-2 rounded bg-green-400 text-white"
                >
                  <PlusIcon className="h-4 w-4" />
                </button>
              );
            } else {
              button = (
                <button
                  onClick={() => decreasePernyataan(idx)}
                  className="p-2 rounded bg-red-400 text-white"
                >
                  <TrashIcon className="h-4 w-4" />
                </button>
              );
            }

            return (
              <div key={idx} className="flex flex-row gap-4">
                <div className="flex flex-1">
                  <textarea
                    rows="1"
                    onChange={(e) => setValue(e.target.value, idx)}
                    className="bg-white w-full p-2 rounded"
                  >
                    {pernyataan[idx]}
                  </textarea>
                </div>
                <div>{button}</div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

// form liklert type 2
const PanePernyataan = (props) => {
  const [mainData, setmainData] = useState(props.mainData ?? {});
  const [initialData, setinitialData] = useState([""]);

  useEffect(() => {
    // setinitialData([""]);
    setinitialData(
      (props.mainData?.pernyataan.length ?? [""]) < 1
        ? [""]
        : props.mainData?.pernyataan
    );
    document.getElementById("type2-0").value =
      props.mainData?.pernyataan[0] ?? "";
  }, []);
  function __increasePernyataan(params) {
    setinitialData([...initialData, ""]);
  }

  function __decreasePernyataan(params) {
    let filtered = initialData.filter((x, y) => y !== params);
    setinitialData(filtered);
  }

  function __setValue(params) {
    let temp = initialData;
    temp[params.idx] = params.value;

    setinitialData(temp);
  }

  function __save(params) {
    props.onSave(initialData);
    props.close();
  }

  console.log("initial", initialData);
  return (
    <div>
      <h1 className="text-lg font-bold my-4">
        Pernyataan untuk {props.mainData?.nama_bab}
      </h1>
      {!!initialData
        ? initialData.map(function (val, idx) {
            let val2 = val;
            let button = null;

            if (idx < 1) {
              button = (
                <button
                  onClick={() => __increasePernyataan()}
                  className="p-2 rounded bg-green-400 text-white"
                >
                  <PlusIcon className="h-4 w-4" />
                </button>
              );
            } else {
              button = (
                <button
                  onClick={() => __decreasePernyataan(idx)}
                  className="p-2 rounded bg-red-400 text-white"
                >
                  <TrashIcon className="h-4 w-4" />
                </button>
              );
            }
            return (
              <div key={idx} className="flex flex-row gap-4 my-1">
                <div className="flex flex-1">
                  {idx === 0 ? (
                    <textarea
                      id={`type2-${idx}`}
                      onChange={(e) =>
                        __setValue({ idx: idx, value: e.target.value })
                      }
                      // value={val}
                      rows="1"
                      className="bg-gray-200 w-full p-2 rounded"
                    >
                      {initialData[0] ?? val}
                    </textarea>
                  ) : (
                    <textarea
                      onChange={(e) =>
                        __setValue({ idx: idx, value: e.target.value })
                      }
                      // value={val}
                      rows="1"
                      className="bg-gray-200 w-full p-2 rounded"
                    >
                      {val2}
                    </textarea>
                  )}
                </div>
                <div>{button}</div>
              </div>
            );
          })
        : null}

      <div className="flex flex-row gap-2 my-2">
        <button
          onClick={() => props.close()}
          className="p-2 flex flex-row items-center gap-2 rounded bg-red-400 text-white"
        >
          <p className="text-sm">Batal</p>
        </button>
        <button
          onClick={() => __save()}
          className="p-2 flex flex-row items-center gap-2 rounded bg-blue-400 text-white"
        >
          <p className="text-sm">Simpan</p>
        </button>
      </div>
    </div>
  );
};
const FormLiklertType2 = (props) => {
  const clickMeButtonRef = useRef();
  const [popOverBuat, setPopOverBuat] = useState(false);
  const [popOverEdit, setPopOverEdit] = useState(false);

  // bab stuff
  const [dataBab, setdataBab] = useState(props.initialData ?? []);
  const [tempBab, settempBab] = useState({});
  const [tabSelectedBab, settabSelectedBab] = useState(null);
  const [editValue, seteditValue] = useState(null);

  // pernytaan stuff
  const [pernyataanPane, setpernyataanPane] = useState(false);
  const [fire, setfire] = useState(false);

  console.log("type 2", dataBab)

  function _formAddBab(params) {
    function addBab(e) {
      setdataBab([...dataBab, tempBab]);
      setPopOverBuat(!popOverBuat);
      saveAll([...dataBab, tempBab]);
    }
    return (
      <div className="flex flex-col">
        <h1 className="text-lg font-bold">Tambah Bab</h1>
        <InputSingle
          type="text"
          placeholder="Nama Bab"
          className="w-full my-4"
          onChange={(e) =>
            settempBab({
              nama_bab: e.target.value,
              pernyataan: [],
            })
          }
        />
        <div className="flex flex-row gap-2 my-1">
          <button
            onClick={() => setPopOverBuat(!popOverBuat)}
            className="p-2 flex flex-row items-center gap-2 rounded bg-red-400 text-white"
          >
            <p>Batal</p>
          </button>
          <button
            onClick={() => addBab()}
            className="p-2 flex flex-row items-center gap-2 rounded bg-blue-400 text-white"
          >
            <p>Tambah Bab</p>
            <PlusIcon className="h-4 w-4" />
          </button>
        </div>
      </div>
    );
  }

  function _formEditBab(params) {
    function _saveEdited(params) {
      let indexx = dataBab.findIndex(
        (x) => x.nama_bab === tabSelectedBab?.nama_bab
      );
      let temp = dataBab;
      temp[indexx].nama_bab = editValue;

      setdataBab(temp);
      setPopOverEdit(!popOverEdit);
      saveAll(temp);
    }
    return (
      <div className="flex flex-col">
        <h1 className="text-lg font-bold">Edit Bab</h1>
        <InputSingle
          type="text"
          placeholder="Nama Bab"
          className="w-full my-4"
          value={editValue}
          onChange={(e) => seteditValue(e.target.value)}
        />
        <div className="flex flex-row gap-2 my-1">
          <button
            onClick={() => setPopOverEdit(!popOverEdit)}
            className="p-2 flex flex-row items-center gap-2 rounded bg-red-400 text-white"
          >
            <p>Batal</p>
          </button>
          <button
            onClick={() => _saveEdited()}
            className="p-2 flex flex-row items-center gap-2 rounded bg-blue-400 text-white"
          >
            <p>Edit Bab</p>
            <PencilIcon className="h-4 w-4" />
          </button>
        </div>
      </div>
    );
  }

  function _deleteBab(params) {
    const filtered = dataBab.filter((val, idx) => idx !== params);
    setdataBab(filtered);
    saveAll(filtered);
  }

  function reciverPernyataan(params) {
    let idx = dataBab.findIndex((x) => x.nama_bab === tabSelectedBab.nama_bab);
    let bab_temp = dataBab;
    let selected_temp = tabSelectedBab;
    bab_temp[idx].pernyataan = params;
    selected_temp.pernyataan = params;

    setdataBab(bab_temp);
    settabSelectedBab(selected_temp);
    saveAll(bab_temp);
  }

  function saveAll(params) {
    props.onSave(params);
  }

  return (
    <div className="flex flex-col">
      <Overlay isOpen={popOverBuat} />
      <Overlay isOpen={popOverEdit} />

      {/* pane pernyataan */}
      <SlidingPane
        closeIcon={<div></div>}
        isOpen={pernyataanPane}
        title="Hey"
        from="right"
        width="40vw"
        onRequestClose={() => setpernyataanPane(false)}
      >
        <PanePernyataan
          close={() => setpernyataanPane(false)}
          mainData={dataBab.find(
            (x) => x.nama_bab === tabSelectedBab?.nama_bab
          )}
          onSave={(e) => reciverPernyataan(e)}
        />
      </SlidingPane>

      <div className="flex flex-col">
        <p className="my-2">Bab</p>
        <div className="flex flex-row gap-2">
          <Popover
            isOpen={popOverBuat}
            positions={["top", "right", "left", "bottom"]}
            padding={10}
            // onClickOutside={() => setPopOverBuat(false)}
            ref={clickMeButtonRef} // if you'd like a ref to your popover's child, you can grab one here
            content={({ position, childRect, popoverRect }) => (
              <ArrowContainer // if you'd like an arrow, you can import the ArrowContainer!
                position={position}
                childRect={childRect}
                popoverRect={popoverRect}
                arrowColor={"white"}
                arrowSize={15}
                arrowStyle={{}}
                className="popover-arrow-container"
                arrowClassName="popover-arrow"
              >
                <div
                  style={{ backgroundColor: "white", minWidth: "400px" }}
                  className="rounded-xl shadow-xl p-6 border"
                >
                  {_formAddBab()}
                </div>
              </ArrowContainer>
            )}
          >
            <button
              onClick={() => setPopOverBuat(!popOverBuat)}
              className="p-2 flex flex-row items-center gap-2 rounded bg-green-400 text-white"
            >
              <p>Tambah Bab</p>
              <PlusIcon className="h-4 w-4" />
            </button>
          </Popover>

          <div className="flex flex-row gap-2 overflow-x-scroll">
            {dataBab.map((val, idx) => {
              if (tabSelectedBab?.nama_bab === val.nama_bab) {
                return (
                  <ButtonPrimary key={idx} text={val.nama_bab} type="solid" />
                );
              } else {
                return (
                  <ButtonPrimary
                    key={idx}
                    onClick={() => {
                      settabSelectedBab(val);
                      seteditValue(val.nama_bab);
                    }}
                    text={val.nama_bab}
                    type="outline"
                  />
                );
              }
            })}
          </div>
        </div>
      </div>

      <div className="flex flex-col mt-4">
        {dataBab.length < 1 ? (
          <div>Klik tambah bab untuk menambahkan</div>
        ) : !!dataBab.find((x) => x.nama_bab === tabSelectedBab?.nama_bab) &&
          !!tabSelectedBab ? (
          <>
            <p className="my-2">Pernyataan - {tabSelectedBab?.nama_bab}</p>

            <div className="flex flex-row justify-between items-center">
              <div className="flex flex-row gap-2 my-2">
                <Popover
                  isOpen={popOverEdit}
                  positions={["top", "right", "left", "bottom"]}
                  padding={10}
                  // onClickOutside={() => setPopOverBuat(false)}
                  ref={clickMeButtonRef} // if you'd like a ref to your popover's child, you can grab one here
                  content={({ position, childRect, popoverRect }) => (
                    <ArrowContainer // if you'd like an arrow, you can import the ArrowContainer!
                      position={position}
                      childRect={childRect}
                      popoverRect={popoverRect}
                      arrowColor={"white"}
                      arrowSize={15}
                      arrowStyle={{}}
                      className="popover-arrow-container"
                      arrowClassName="popover-arrow"
                    >
                      <div
                        style={{ backgroundColor: "white", minWidth: "400px" }}
                        className="rounded-xl shadow-xl p-6 border"
                      >
                        {_formEditBab({ value: tabSelectedBab?.nama_bab })}
                      </div>
                    </ArrowContainer>
                  )}
                >
                  <button
                    onClick={() => setPopOverEdit(!popOverEdit)}
                    className="p-2 flex flex-row items-center gap-2 rounded bg-blue-400 text-white"
                  >
                    <PencilIcon className="h-4 w-4" />
                    <p className="text-sm">Edit {tabSelectedBab?.nama_bab}</p>
                  </button>
                </Popover>

                <button
                  onClick={() =>
                    _deleteBab(
                      dataBab.findIndex(
                        (x) => x.nama_bab === tabSelectedBab?.nama_bab
                      )
                    )
                  }
                  className="p-2 flex flex-row items-center gap-2 rounded bg-red-400 text-white"
                >
                  <TrashIcon className="h-4 w-4" />
                  <p className="text-sm">Hapus {tabSelectedBab?.nama_bab}</p>
                </button>
              </div>
              <div>
                <button
                  onClick={() => {
                    setpernyataanPane(!pernyataanPane);
                  }}
                  className="p-2 flex flex-row items-center gap-2 rounded bg-green-400 text-white"
                >
                  <PencilIcon className="h-4 w-4" />
                  <p className="text-sm">
                    Tambah Pernyataan / Edit Pernyataan{" "}
                    {tabSelectedBab?.nama_bab}
                  </p>
                </button>
              </div>
            </div>
            <div className="flex flex-col gap-2 ">
              {tabSelectedBab?.pernyataan.map((val, idx) => {
                return (
                  <div className="px-4 py-2 rounded bg-blue-200">
                    <p key={idx}>{val}</p>
                  </div>
                );
              })}
              {/* {!!tabSelectedBab ? _formPernyataan() : null} */}
            </div>
          </>
        ) : (
          <div>Pilih Bab</div>
        )}
      </div>
    </div>
  );
};

// form liklert type 3
const FormSubBab = (props) => {
  const [dataBab, setdataBab] = useState({});
  const [initialData, setinitialData] = useState({
    id: null,
    nama_sub_bab: "",
    pernyataan: [""],
  });
  const [fireval, setfireval] = useState(false);

  useEffect(() => {
    setdataBab({ nama_bab: props.dataBab ?? "" });
    if (props.edit) {
      setinitialData(props.mainData);
    }
    // setinitialData(
    //   (props.mainData?.pernyataan.length ?? {nama_sub_bab: "", pernyataan: [""]}) < 1
    //     ? [""]
    //     : props.mainData?.pernyataan
    // );
  }, []);
  function __increasePernyataan(params) {
    setinitialData({
      id: initialData.id,
      nama_sub_bab: initialData.nama_sub_bab,
      pernyataan: [...initialData.pernyataan, ""],
    });
  }

  function __decreasePernyataan(params) {
    let filtered = initialData.pernyataan.filter((x, y) => y !== params);
    console.log("filtered", filtered);
    setinitialData({
      id: initialData.id,
      nama_sub_bab: initialData.nama_sub_bab,
      pernyataan: filtered,
    });
  }

  function __setValue(params) {
    let temp = initialData;
    temp.pernyataan[params.idx] = params.value;

    setinitialData(temp);
    setfireval(!fireval);
  }

  function __save(params) {
    props.onSave({ data_sub_bab: initialData, data_bab: dataBab });
    if (!props.edit) {
      props.close();
    }
  }

  return (
    <div>
      <h1 className="text-lg font-bold my-4">
        {props.edit ? "Edit" : "Form"} Sub Bab & Pernyataan
      </h1>
      <div className="flex flex-col flex-1 w-full">
        <p className="text-sm">Sub Bab</p>
        <InputSingle
          value={initialData.nama_sub_bab}
          onChange={(e) => {
            let id = props.edit ? initialData.id : Date.now();
            setinitialData({
              id: id,
              nama_sub_bab: e.target.value,
              pernyataan: initialData.pernyataan,
            });
          }}
          className="w-full"
        />
      </div>
      <p className="text-sm">Pernyataan</p>
      {initialData?.pernyataan.map(function (val, idx) {
        let vaal = val;
        let button = null;

        console.log(val);

        if (idx === 0) {
          button = (
            <button
              onClick={() => __increasePernyataan()}
              className="p-2 rounded bg-green-400 text-white"
            >
              <PlusIcon className="h-4 w-4" />
            </button>
          );
        } else {
          button = (
            <button
              onClick={() => __decreasePernyataan(idx)}
              className="p-2 rounded bg-red-400 text-white"
            >
              <TrashIcon className="h-4 w-4" />
            </button>
          );
        }
        if (!!val || val === "") {
          return (
            <div key={idx} className="flex flex-row gap-4 my-1">
              <div className="flex flex-1">
                <textarea
                  onChange={(e) =>
                    __setValue({ idx: idx, value: e.target.value })
                  }
                  rows="1"
                  value={initialData.pernyataan[idx]}
                  className="bg-gray-200 w-full p-2 rounded"
                ></textarea>
              </div>
              <div>{button}</div>
            </div>
          );
        }
      })}

      <div className="flex flex-row gap-2 my-2">
        <button
          onClick={() => props.close()}
          className="p-2 flex flex-row items-center gap-2 rounded bg-red-400 text-white"
        >
          <p className="text-sm">Batal</p>
        </button>
        <button
          onClick={() => __save()}
          className="p-2 flex flex-row items-center gap-2 rounded bg-blue-400 text-white"
        >
          <p className="text-sm">Simpan</p>
        </button>
      </div>
    </div>
  );
};
const FormLiklertType3 = (props) => {
  const clickMeButtonRef = useRef();
  const [popOverBuat, setPopOverBuat] = useState(false);
  const [popOverEdit, setPopOverEdit] = useState(false);

  // bab stuff
  // const [dataBab, setdataBab] = useState([]); // Real
  const [dataBab, setdataBab] = useState(props.initialData ?? []); // dummy
  const [tempBab, settempBab] = useState({});
  const [tabSelectedBab, settabSelectedBab] = useState(null);
  const [editValue, seteditValue] = useState(null);

  // pernytaan stuff
  const [pernyataanPane, setpernyataanPane] = useState(false);

  // edit sub
  const [paneEditSub, setpaneEditSub] = useState(false);
  const [dataToEdit, setdataToEdit] = useState(null);

  const [modalHapus, setmodalHapus] = useState(null);

  function _formAddBab(params) {
    function addBab(e) {
      setdataBab([...dataBab, tempBab]);
      setPopOverBuat(!popOverBuat);
      saveAll([...dataBab, tempBab]);
    }
    return (
      <div className="flex flex-col">
        <h1 className="text-lg font-bold">Tambah Bab</h1>
        <InputSingle
          type="text"
          placeholder="Nama Bab"
          className="w-full my-4"
          onChange={(e) =>
            settempBab({
              nama_bab: e.target.value,
              sub_bab: [],
            })
          }
        />
        <div className="flex flex-row gap-2 my-1">
          <button
            onClick={() => setPopOverBuat(!popOverBuat)}
            className="p-2 flex flex-row items-center gap-2 rounded bg-red-400 text-white"
          >
            <p>Batal</p>
          </button>
          <button
            onClick={() => addBab()}
            className="p-2 flex flex-row items-center gap-2 rounded bg-blue-400 text-white"
          >
            <p>Tambah Bab</p>
            <PlusIcon className="h-4 w-4" />
          </button>
        </div>
      </div>
    );
  }

  function _formEditBab(params) {
    function _saveEdited(params) {
      let indexx = dataBab.findIndex(
        (x) => x.nama_bab === tabSelectedBab?.nama_bab
      );
      let temp = dataBab;
      temp[indexx].nama_bab = editValue;

      setdataBab(temp);
      setPopOverEdit(!popOverEdit);
      saveAll(temp);
    }
    return (
      <div className="flex flex-col">
        <h1 className="text-lg font-bold">Edit Bab</h1>
        <InputSingle
          type="text"
          placeholder="Nama Bab"
          className="w-full my-4"
          value={editValue}
          onChange={(e) => seteditValue(e.target.value)}
        />
        <div className="flex flex-row gap-2 my-1">
          <button
            onClick={() => setPopOverEdit(!popOverEdit)}
            className="p-2 flex flex-row items-center gap-2 rounded bg-red-400 text-white"
          >
            <p>Batal</p>
          </button>
          <button
            onClick={() => _saveEdited()}
            className="p-2 flex flex-row items-center gap-2 rounded bg-blue-400 text-white"
          >
            <p>Edit Bab</p>
            <PencilIcon className="h-4 w-4" />
          </button>
        </div>
      </div>
    );
  }

  function _deleteBab(params) {
    const filtered = dataBab.filter((val, idx) => idx !== params);
    setdataBab(filtered);
    saveAll(filtered);
  }

  function _deleteSubBab(params) {
    let bab_temp = dataBab;
    let selected_temp = tabSelectedBab;
    let idx = dataBab.findIndex((x) => x.nama_bab === tabSelectedBab.nama_bab);
    let filtered = dataBab[idx].sub_bab.filter((x, y) => y !== params);

    bab_temp[idx].sub_bab = filtered;
    settabSelectedBab(bab_temp[idx]);
    setdataBab(bab_temp);
    setmodalHapus(null);

    saveAll(bab_temp);
  }

  function reciverCreateSub(params) {
    let bab_temp = dataBab;
    let selected_temp = tabSelectedBab;
    let idx = dataBab.findIndex((x) => x.nama_bab === tabSelectedBab.nama_bab);

    bab_temp[idx].sub_bab = [...dataBab[idx].sub_bab, params.data_sub_bab];
    // selected_temp.sub_bab = [...tabSelectedBab.sub_bab, params.data_sub_bab];

    // console.log(bab_temp, selected_temp, params);

    setdataBab(bab_temp);

    saveAll(bab_temp);
  }

  function reciverEditSub(params) {
    console.log("edited", params);
    let bab_temp = dataBab;
    let selected_temp = tabSelectedBab;
    let idx = dataBab.findIndex((x) => x.nama_bab === tabSelectedBab.nama_bab);
    let idx2 = dataBab[idx].sub_bab.findIndex(
      (x) => x.id === params.data_sub_bab.id
    );

    bab_temp[idx].sub_bab[idx2] = params.data_sub_bab;

    console.log(
      bab_temp,
      dataBab[idx].sub_bab.findIndex((x) => x.id === params.data_sub_bab.id)
    );

    setdataBab(bab_temp);
    setdataToEdit(null);

    saveAll(bab_temp);
  }

  function saveAll(params) {
    props.onSave(params);
  }

  console.log("al", dataBab);

  return (
    <div className="flex flex-col">
      <Overlay isOpen={popOverBuat} />
      <Overlay isOpen={popOverEdit} />

      {/* Modal delete sub */}
      <SMModal
        title="Konfirmasi"
        show={!!modalHapus}
        onClose={() => setmodalHapus(null)}
        disableOverlayClose={true}
      >
        <div className="flex flex-col">
          <p className="my-2">Hapus sub bab ini?</p>

          <div className="flex flex-row gap-2">
            <button
              onCLick={() => setmodalHapus(null)}
              className="p-2 flex flex-row items-center gap-2 rounded bg-blue-400 text-white"
            >
              <p className="text-sm">Batal</p>
            </button>
            <button
              onClick={() => _deleteSubBab(modalHapus - 1)}
              className="p-2 flex flex-row items-center gap-2 rounded bg-red-400 text-white"
            >
              <p className="text-sm">Hapus</p>
            </button>
          </div>
        </div>
      </SMModal>

      {/* pane add sub */}
      <SlidingPane
        closeIcon={<div></div>}
        isOpen={pernyataanPane}
        title="Hey"
        from="right"
        width="40vw"
        onRequestClose={() => setpernyataanPane(false)}
      >
        <FormSubBab
          close={() => setpernyataanPane(false)}
          mainData={dataBab.find(
            (x) => x.nama_bab === tabSelectedBab?.nama_bab
          )}
          dataBab={tabSelectedBab}
          onSave={(e) => reciverCreateSub(e)}
          edit={false}
        />
      </SlidingPane>

      {/* pane edit sub */}
      <SlidingPane
        closeIcon={<div></div>}
        isOpen={!!dataToEdit}
        title="Hey"
        from="right"
        width="40vw"
        onRequestClose={() => setdataToEdit(null)}
      >
        <FormSubBab
          close={() => setdataToEdit(null)}
          mainData={dataToEdit}
          dataBab={tabSelectedBab}
          onSave={(e) => reciverEditSub(e)}
          edit={true}
        />
      </SlidingPane>

      <div className="flex flex-col">
        {/* <p className="my-2">Bab</p> */}
        <div className="flex flex-row gap-2">
          <Popover
            isOpen={popOverBuat}
            positions={["top", "right", "left", "bottom"]}
            padding={10}
            // onClickOutside={() => setPopOverBuat(false)}
            ref={clickMeButtonRef} // if you'd like a ref to your popover's child, you can grab one here
            content={({ position, childRect, popoverRect }) => (
              <ArrowContainer // if you'd like an arrow, you can import the ArrowContainer!
                position={position}
                childRect={childRect}
                popoverRect={popoverRect}
                arrowColor={"white"}
                arrowSize={15}
                arrowStyle={{}}
                className="popover-arrow-container"
                arrowClassName="popover-arrow"
              >
                <div
                  style={{ backgroundColor: "white", minWidth: "400px" }}
                  className="rounded-xl shadow-xl p-6 border"
                >
                  {_formAddBab()}
                </div>
              </ArrowContainer>
            )}
          >
            <button
              onClick={() => setPopOverBuat(!popOverBuat)}
              className="p-2 flex flex-row items-center gap-2 rounded bg-green-400 text-white"
            >
              <p>Tambah Bab</p>
              <PlusIcon className="h-4 w-4" />
            </button>
          </Popover>

          <div className="flex flex-row gap-2 overflow-x-scroll">
            {dataBab.map((val, idx) => {
              if (tabSelectedBab?.nama_bab === val.nama_bab) {
                return (
                  <ButtonPrimary key={idx} text={val.nama_bab} type="solid" />
                );
              } else {
                return (
                  <ButtonPrimary
                    key={idx}
                    onClick={() => {
                      settabSelectedBab(val);
                      seteditValue(val.nama_bab);
                    }}
                    text={val.nama_bab}
                    type="outline"
                  />
                );
              }
            })}
          </div>
        </div>
      </div>

      <div className="flex flex-col mt-4">
        {dataBab.length < 1 ? (
          <div>Klik tambah bab untuk menambahkan</div>
        ) : !!dataBab.find((x) => x.nama_bab === tabSelectedBab?.nama_bab) &&
          !!tabSelectedBab ? (
          <>
            <p className="my-2 text-lg font-bold">
              Pernyataan - {tabSelectedBab?.nama_bab}
            </p>

            <div className="flex flex-row justify-between items-center">
              <div className="flex flex-row gap-2 my-2">
                <Popover
                  isOpen={popOverEdit}
                  positions={["top", "right", "left", "bottom"]}
                  padding={10}
                  // onClickOutside={() => setPopOverBuat(false)}
                  ref={clickMeButtonRef} // if you'd like a ref to your popover's child, you can grab one here
                  content={({ position, childRect, popoverRect }) => (
                    <ArrowContainer // if you'd like an arrow, you can import the ArrowContainer!
                      position={position}
                      childRect={childRect}
                      popoverRect={popoverRect}
                      arrowColor={"white"}
                      arrowSize={15}
                      arrowStyle={{}}
                      className="popover-arrow-container"
                      arrowClassName="popover-arrow"
                    >
                      <div
                        style={{ backgroundColor: "white", minWidth: "400px" }}
                        className="rounded-xl shadow-xl p-6 border"
                      >
                        {_formEditBab({ value: tabSelectedBab?.nama_bab })}
                      </div>
                    </ArrowContainer>
                  )}
                >
                  <button
                    onClick={() => setPopOverEdit(!popOverEdit)}
                    className="p-2 flex flex-row items-center gap-2 rounded bg-blue-400 text-white"
                  >
                    <PencilIcon className="h-4 w-4" />
                    <p className="text-sm">Edit {tabSelectedBab?.nama_bab}</p>
                  </button>
                </Popover>

                <button
                  onClick={() =>
                    _deleteBab(
                      dataBab.findIndex(
                        (x) => x.nama_bab === tabSelectedBab?.nama_bab
                      )
                    )
                  }
                  className="p-2 flex flex-row items-center gap-2 rounded bg-red-400 text-white"
                >
                  <TrashIcon className="h-4 w-4" />
                  <p className="text-sm">Hapus {tabSelectedBab?.nama_bab}</p>
                </button>
              </div>
              <div>
                <button
                  onClick={() => {
                    setpernyataanPane(!pernyataanPane);
                  }}
                  className="p-2 flex flex-row items-center gap-2 rounded bg-green-400 text-white"
                >
                  <PencilIcon className="h-4 w-4" />
                  <p className="text-sm">
                    Tambah / Edit Sub Bab & Pernyataan{" "}
                    {tabSelectedBab?.nama_bab}
                  </p>
                </button>
              </div>
            </div>
            <div className="flex flex-col gap-2 rounded-lg bg-gray-100 p-6">
              {tabSelectedBab?.sub_bab.map((val, idx) => {
                return (
                  <div className="flex flex-col">
                    <div className="flex flex-row justify-between items-center px-4 py-2 rounded bg-blue-200">
                      <p key={idx} className="text-lg font-bold my-2">
                        {val.nama_sub_bab}
                      </p>
                      <div className="flex flex-row gap-2">
                        <button
                          onClick={() => setdataToEdit(val)}
                          className="p-2 flex flex-row items-center gap-2 rounded bg-blue-400 text-white"
                        >
                          <PencilIcon className="h-4 w-4" />
                          <p className="text-sm">Edit {val.nama_sub_bab}</p>
                        </button>
                        <button
                          onClick={() => setmodalHapus(idx + 1)}
                          className="p-2 flex flex-row items-center gap-2 rounded bg-red-400 text-white"
                        >
                          <TrashIcon className="h-4 w-4" />
                          <p className="text-sm">Hapus {val.nama_sub_bab}</p>
                        </button>
                      </div>
                    </div>
                    <div className="flex flex-col px-4">
                      {val.pernyataan.map((val2, idx2) => {
                        return (
                          <div
                            key={idx2}
                            className="flex p-2 my-1 rounded bg-blue-100"
                          >
                            <p>{val2}</p>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                );
              })}
              {/* {!!tabSelectedBab ? _formPernyataan() : null} */}
            </div>
          </>
        ) : (
          <div>Pilih Bab</div>
        )}
      </div>
    </div>
  );
};

const EditKuesionerLiklert = () => {
  const history = useHistory();
  let { idKuesioner } = useParams();
  // State
  const [loadingGetData, setloadingGetData] = useState(false);
  const [modalPeringatanKategori, setmodalPeringatanKategori] = useState(false);
  const [selectedKategori, setselectedKategori] = useState(0); // default 0
  const [tempKategori, settempKategori] = useState("Pilih Kategori");
  const [itemSkala, setitemSkala] = useState([
    { key: "", keterangan: "" },
    { key: "", keterangan: "" },
  ]);

  const [dataLiklert, setdataLiklert] = useState([]);

  // state pane
  const [paneSkala, setpaneSkala] = useState(false);
  const [panePreview, setpanePreview] = useState(false);
  let data_kategori = [
    { value: 0, label: "Pilih Kategori" },
    { value: 1, label: "Pernyataan" },
    { value: 2, label: "Bab & Pernyataan" },
    { value: 3, label: "Bab, Sub Bab, & Pernyataan" },
  ];

  const [tabPreview, settabPreview] = useState(null);
  const [modalSimpan, setmodalSimpan] = useState(false);
  const [statusSimpan, setstatusSimpan] = useState(0);
  const [kuesioner, setkuesioner] = useState({});
  const [number, setnumber] = useState(0);

  useEffect(() => {
    let tempKuesioner = JSON.parse(
      localStorage.getItem("temp_edit_kuesioner")
    );

    if (!!tempKuesioner) {
      setkuesioner(tempKuesioner);
    }

    getData();
  }, []);

  function getData() {
    setloadingGetData(true);
    axiosAPI
      .get(API + "kuesioner/" + idKuesioner + "?include=dataSoal")
      .then((res) => {
        console.log(res.data.data);
        let data = res.data.data;

        if (data.relationships.dataKategori === 1) {
          settempKategori(data_kategori[1].label);
          setselectedKategori(data_kategori[1].value);
        } else if (data.relationships.dataKategori === 2) {
          settempKategori(data_kategori[2].label);
          setselectedKategori(data_kategori[2].value);
        } else if (data.relationships.dataKategori === 3) {
          settempKategori(data_kategori[3].label);
          setselectedKategori(data_kategori[3].value);
        } else {
          settempKategori(data_kategori[0].label);
          setselectedKategori(data_kategori[0].value);
        }
        // set dkala
        setitemSkala(data.relationships.dataSkala);
        setdataLiklert(data.relationships.dataSoal);

        setloadingGetData(false);
      })
      .catch((err) => {
        setloadingGetData(false);
      });
  }

  function switchKategori(e, method) {
    // lv = label -> value
    // vl = value -> label

    let res = null;

    if (method === "lv") {
      res = data_kategori.find((x) => x.label === e).value ?? "Pilih Kategori";
    } else {
      res = data_kategori.find((x) => x.value === e).label ?? 0;
    }

    return res;
  }

  function selectKategori(e) {
    setselectedKategori(switchKategori(tempKategori, "lv"));
  }

  // PaneView
  function viewPaneSkala(params) {
    return (
      <SlidingPane
        closeIcon={<div></div>}
        isOpen={paneSkala}
        title="Hey"
        from="right"
        width="40vw"
        onRequestClose={() => setpaneSkala(false)}
      >
        <FormSkala
          initialSkala={itemSkala}
          save={(e) => setitemSkala(e)}
          close={() => setpaneSkala(false)}
        />
      </SlidingPane>
    );
  }

  function viewLiklert(params) {
    if (selectedKategori === 1) {
      return (
        <FormLiklertType1
          selectedKategori={selectedKategori}
          onSave={(e) => setdataLiklert(e)}
          initialData={dataLiklert}
        />
      );
    } else if (selectedKategori === 2) {
      return (
        <FormLiklertType2
          selectedKategori={selectedKategori}
          onSave={(e) => setdataLiklert(e)}
          initialData={dataLiklert}
        />
      );
    } else if (selectedKategori === 3) {
      return (
        <FormLiklertType3
          selectedKategori={selectedKategori}
          onSave={(e) => setdataLiklert(e)}
          initialData={dataLiklert}
        />
      );
    } else {
      return (
        <div className="flex flex-col w-full h-full">
          <h1 className="text-lg font-bold mx-auto my-auto">
            Pilih Kategori Dulu
          </h1>
        </div>
      );
    }
  }

  function countDown(params) {
    let number = params ?? 3;
    setnumber(params);
    if (number > 0) {
      setInterval(() => {
        number = number - 1;
        if (number >= 0) {
          setnumber(number);
        }
      }, 1000);
    }
  }

  // simpan
  function create(params) {
    // status simpan
    // 0 = IDLE
    // 1 = SUCCEDDED
    // 2 = FAILED
    // 3 = ON_PROCCESS
    let body = {
      info_panduan: kuesioner,
      liklert: {
        item_soal: dataLiklert,
        kategori: selectedKategori,
        skala: {
          jumlah: itemSkala.length,
          item_skala: itemSkala,
        },
      },
    };
    if (selectedKategori === 1) {
      body = {
        info_panduan: kuesioner,
        liklert: {
          item_soal: [{ pernyataan: dataLiklert }],
          kategori: selectedKategori,
          skala: {
            jumlah: itemSkala.length,
            item_skala: itemSkala,
          },
        },
      };
    }
    setstatusSimpan(3);
    axiosAPI
      .post(API + "kuesioner/"+idKuesioner+"/edit-liklert", body)
      .then((res) => {
        if (res.data.status === "success") {
          setstatusSimpan(1);
          localStorage.removeItem("temp_edit_soal_liklert");
          localStorage.removeItem("temp_edit_kuesioner");
          localStorage.removeItem("queue_edit_kuesioner");
          countDown(3);
          setTimeout(() => {
            window.location.replace("/daftar-kuesioner")
          }, 3000);
        } else {
          setstatusSimpan(2);
          localStorage.setItem(
            "queue_edit_kuesioner",
            JSON.stringify({
              kuesioner: "temp_edit_kuesioner",
              type: "liklert",
            })
          );
        }
      })
      .catch((err) => {
        setstatusSimpan(2);
        localStorage.setItem(
          "queue_edit_kuesioner",
          JSON.stringify({
            kuesioner: "temp_edit_kuesioner",
            type: "liklert",
          })
        );
      });
  }

  function viewPreview(params) {
    function view1(params) {
      return (
        <div className="flex flex-col w-100">
          <table className="mb-4 w-full">
            <tr className="text-left">
              <th>Nomor</th>
              <th>Pernyataan</th>
              {itemSkala.map((val, idx) => {
                return <th key={idx}>{val.keterangan}</th>;
              })}
            </tr>
            {dataLiklert.map((val, idx) => {
              return (
                <tr>
                  <td>{idx + 1}</td>
                  <td>{val}</td>
                  {itemSkala.map((val2, idx2) => {
                    // return <td key={idx}>{val.key}</td>;
                    return (
                      <td key={idx2}>
                        <div className="flex items-center flex-row">
                          <input
                            type="radio"
                            id={`${idx2}-skala`}
                            name={`${val}-skala`}
                          />
                          <label for={`${idx2}-skala`}>{val2.keterangan}</label>
                        </div>
                      </td>
                    );
                  })}
                </tr>
              );
            })}
          </table>
        </div>
      );
    }

    function view2(params) {
      return (
        <div className="flex flex-col w-100">
          <p></p>
          <div className="flex flex-row gap-4 overflow-x-scroll">
            {dataLiklert.map((val, idx) => {
              // return <button onClick={() => settabPreview(val.nama_bab)} key={idx}>{val.nama_bab}</button>;
              if (val.nama_bab === tabPreview) {
                return (
                  <ButtonPrimary
                    text={val.nama_bab}
                    type="solid"
                    onClick={() => settabPreview(val.nama_bab)}
                  />
                );
              } else {
                return (
                  <ButtonPrimary
                    text={val.nama_bab}
                    type="outline"
                    onClick={() => settabPreview(val.nama_bab)}
                  />
                );
              }
            })}
          </div>
          {!!dataLiklert.find((x) => x.nama_bab === tabPreview) &&
          !!tabPreview ? (
            <table className="mb-4 w-full">
              <tr className="text-left">
                <th>Nomor</th>
                <th>Pertanyaan</th>
                {itemSkala.map((val, idx) => {
                  return <th key={idx}>{val.keterangan}</th>;
                })}
              </tr>
              {dataLiklert
                .find((x) => x.nama_bab === tabPreview)
                .pernyataan.map((val, idx) => {
                  return (
                    <tr>
                      <td>{idx + 1}</td>
                      <td>{val}</td>
                      {itemSkala.map((val2, idx2) => {
                        // return <td key={idx}>{val.key}</td>;
                        return (
                          <td key={idx2}>
                            <div className="flex items-center flex-row">
                              <input
                                type="radio"
                                id={`${idx2}-skala`}
                                name={`${val}-skala`}
                              />
                              <label for={`${idx2}-skala`}>
                                {val2.keterangan}
                              </label>
                            </div>
                          </td>
                        );
                      })}
                    </tr>
                  );
                })}
            </table>
          ) : null}
        </div>
      );
    }

    function view3(params) {
      return (
        <div className="flex flex-col w-100">
          <p></p>
          <div className="flex flex-row gap-4 overflow-x-scroll">
            {dataLiklert.map((val, idx) => {
              // return <button onClick={() => settabPreview(val.nama_bab)} key={idx}>{val.nama_bab}</button>;
              if (val.nama_bab === tabPreview) {
                return (
                  <ButtonPrimary
                    text={val.nama_bab}
                    type="solid"
                    onClick={() => settabPreview(val.nama_bab)}
                  />
                );
              } else {
                return (
                  <ButtonPrimary
                    text={val.nama_bab}
                    type="outline"
                    onClick={() => settabPreview(val.nama_bab)}
                  />
                );
              }
            })}
          </div>
          {!!dataLiklert.find((x) => x.nama_bab === tabPreview) && !!tabPreview
            ? dataLiklert
                .find((x) => x.nama_bab === tabPreview)
                .sub_bab.map((val, idx) => {
                  return (
                    <div key={idx} className="my-2 border-b">
                      <p className="my-4 text-lg font-bold">
                        {val.nama_sub_bab}
                      </p>
                      <table className="mb-4 w-full">
                        <tr className="text-left">
                          <th>Nomor</th>
                          <th>Pertanyaan</th>
                          {itemSkala.map((val, idx) => {
                            return <th key={idx}>{val.keterangan}</th>;
                          })}
                        </tr>
                        {val.pernyataan.map((val, idx) => {
                          return (
                            <tr>
                              <td>{idx + 1}</td>
                              <td>{val}</td>
                              {itemSkala.map((val2, idx2) => {
                                // return <td key={idx}>{val.key}</td>;
                                return (
                                  <td key={idx2}>
                                    <div className="flex items-center flex-row">
                                      <input
                                        type="radio"
                                        id={`${idx2}-skala`}
                                        name={`${val}-skala`}
                                      />
                                      <label for={`${idx2}-skala`}>
                                        {val2.keterangan}
                                      </label>
                                    </div>
                                  </td>
                                );
                              })}
                            </tr>
                          );
                        })}
                      </table>
                    </div>
                  );
                })
            : null}
        </div>
      );
    }
    function renderView(params) {
      if (selectedKategori === 1) {
        return view1();
      } else if (selectedKategori === 2) {
        return view2();
      } else if (selectedKategori === 3) {
        return view3();
      }
    }
    return (
      <SlidingPane
        closeIcon={<div></div>}
        isOpen={panePreview}
        title="Hey"
        from="right"
        width="60vw"
        onRequestClose={() => setpanePreview(false)}
      >
        <div>{renderView()}</div>
      </SlidingPane>
    );
  }

  function viewModalSimpan(params) {
    if (statusSimpan === 3) {
      return (
        <div className="p-4">
          <p>Sedang menyimpan data ...</p>
        </div>
      );
    } else if (statusSimpan === 2) {
      return (
        <div className="p-4">
          <p>Gagal menyimpan data</p>
          <div className="flex flex-row py-6 gap-2">
            <button
              onClick={() => create()}
              className="flex flex-row items-center rounded px-4 py-2 bg-blue-400 text-white"
            >
              Ulangi
            </button>
          </div>
        </div>
      );
    } else if (statusSimpan === 1) {
      return (
        <div className="p-4">
          <p>
            Berhasil menyimpan data, anda akan dialihkan ke halaman daftar
            kuesioner dalam {number} detik
          </p>
          <div className="flex flex-row py-6 gap-2"></div>
        </div>
      );
    }
    return (
      <div className="p-4">
        <p>Simpan data anda</p>
        <div className="flex flex-row py-6 gap-2">
          <button
            onClick={() => setmodalSimpan(!modalSimpan)}
            className="flex flex-row items-center rounded px-4 py-2 bg-red-400 text-white"
          >
            Batal
          </button>
          <button
            onClick={() => create()}
            className="flex flex-row items-center rounded px-4 py-2 bg-blue-400 text-white"
          >
            Ya
          </button>
        </div>
      </div>
    );
  }

  console.log(dataLiklert)
  return (
    <>
      {/* Modal peringatan kategori */}
      <SMModal
        title="Peringatan"
        show={modalPeringatanKategori}
        onClose={() => setmodalPeringatanKategori(!modalPeringatanKategori)}
      >
        <div className="flex flex-col p-4">
          <h1 className="text-lg font-bold">Apakah anda yakin?</h1>
          <p>
            Jika anda mengganti kategori likert, maka semua bab / sub bab /
            pernyataan akan hilang
          </p>

          <div className="flex flex-row gap-4 my-4">
            <button
              className="px-4 py-2 rounded bg-red-400 text-white"
              onClick={() => {
                selectKategori(tempKategori);
                setmodalPeringatanKategori(!modalPeringatanKategori);
              }}
            >
              Ya, saya yakin
            </button>
            <button
              className="px-4 py-2 rounded bg-blue-400 text-white"
              onClick={() =>
                setmodalPeringatanKategori(!modalPeringatanKategori)
              }
            >
              Batal
            </button>
          </div>
        </div>
      </SMModal>

      {/* modal simpan */}
      <SMModal
        title="Konfirmasi"
        show={modalSimpan}
        onClose={() => setmodalSimpan(!modalSimpan)}
      >
        {viewModalSimpan()}
      </SMModal>

      {/* Pane */}
      {viewPaneSkala()}
      {viewPreview()}
      <div
        className="w-full flex flex-col dark:text-white pt-16 px-10"
        style={{ minHeight: "100vh" }}
      >
        {/* <p>{dataLiklert}</p> */}
        <div className="flex flex-col w-full">
          <div className="flex flex-row items-center justify-between">
            <h1 className="text-xl font-bold">
              BUAT INSTRUMEN <br />
              KUESIONER LIKLERT
            </h1>

            <div className="flex flex-row gap-2">
              <button
                onClick={() => setpanePreview(!panePreview)}
                className="px-4 py-1 rounded-lg bg-gray-300"
              >
                Preview Soal
              </button>
              <ButtonPrimary
                onClick={() => setmodalSimpan(!modalSimpan)}
                text="Simpan Kuesioner"
                type="solid"
              />
            </div>
          </div>
        </div>

        {loadingGetData ? null : (
          <div className="flex flex-row w-full pt-16">
            <div className="w-3/12 flex flex-col pr-6">
              <div className="flex flex-col">
                <p>Pilih Kategori</p>
                <select
                  className="bg-gray-200 py-2 rounded-lg px-2"
                  name="kategori"
                  id="kategori"
                  value={switchKategori(selectedKategori, "vl")}
                  onChange={(e) => {
                    settempKategori(e.target.value);
                    setmodalPeringatanKategori(!modalPeringatanKategori);
                  }}
                >
                  {data_kategori.map((val, idx) => {
                    return (
                      <option key={idx} value={val.idx}>
                        {val.label}
                      </option>
                    );
                  })}
                </select>
                {/* <SMSelect data={data_kategori} onChange={(e) => alert("anjinc")} /> */}
              </div>
              <div className="flex flex-col my-4">
                <ButtonPrimary
                  text="Pengaturan Skala"
                  type="solid"
                  onClick={() => setpaneSkala(true)}
                />
              </div>
            </div>
            <div className="w-9/12 bg-gray-200 p-4 rounded-xl">
              {viewLiklert()}
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default EditKuesionerLiklert;
